import { baseState, baseMutations } from '@/store/mixins'
import LogicalPosition from '@/api/hr/logical-position'
import PositionLevel from '@/api/hr/position-level'
import JobTitle from '@/api/hr/job-title'
import OrgChartStructure from '@/api/hr/org-chart-structure'

export const state = {
  ...baseState,
  positionLevels: [],
  jobTitles: [],
  orgChartStructures: [],
  reportedToPositions: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,

  RECEIVE_POSITION_LEVELS(state, positionLevels) {
    state.positionLevels = positionLevels
  },

  RECEIVE_JOB_TITLES(state, jobTitles) {
    state.jobTitles = jobTitles
  },

  RECEIVE_ORG_CHART_STRUCTURES(state, orgChartStructures) {
    state.orgChartStructures = orgChartStructures
  },

  RECEIVE_REPORTED_TO_POSITIONS(state, reportedToPositions) {
    state.reportedToPositions = reportedToPositions
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        ...context.state.queryBuilder
      },
      attributes
    )

    context.commit('SET_QUERY_BUILDER', attributes)

    return LogicalPosition.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return LogicalPosition.store(data)
  },

  update(context, { id, ...data }) {
    return LogicalPosition.update(id, data)
  },

  destroy(context, id) {
    return LogicalPosition.destroy(id).then(response => {
      let resource = context.state.resources.find(r => r.position_id == id)

      if (resource) {
        context.state.resources.splice(context.state.resources.indexOf(resource), 1)
      }

      return response
    })
  },

  async fetchPositionLevels({ commit }) {
    const response = await PositionLevel.get({ params: { page: -1 } })
    commit('RECEIVE_POSITION_LEVELS', response.data)
  },

  async fetchJobTitles({ commit }) {
    const response = await JobTitle.get({ params: { page: -1 } })
    commit('RECEIVE_JOB_TITLES', response.data)
  },

  async fetchOrgChartStructures({ commit }) {
    const response = await OrgChartStructure.get({ params: { page: -1 } })
    commit('RECEIVE_ORG_CHART_STRUCTURES', response.data)
  },

  async fetchHigherPositions({ commit }, orgChartStructureId) {
    commit('RECEIVE_REPORTED_TO_POSITIONS', [])
    const response = await LogicalPosition.getHigherLevelPosition({
      params: { org_chart_structure_id: orgChartStructureId }
    })
    commit('RECEIVE_REPORTED_TO_POSITIONS', response.data)
  }
}
